import { CurrencyInput, Grid, TextField } from "../../../../components";

const FormFiltroAvancado = ({ valueInput, onChangeInput, onBlurInput }) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            id="codigo"
            name="codigo"
            label="Código"
            fullWidth
            margin="normal"
            variant="outlined"
            onChange={(event) => onChangeInput(event)}
            value={valueInput("codigo")}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            id="nome"
            name="nome"
            label="Nome"
            fullWidth
            margin="normal"
            variant="outlined"
            onChange={(event) => onChangeInput(event)}
            value={valueInput("nome")}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            id="descricao"
            name="descricao"
            label="Descrição"
            fullWidth
            margin="normal"
            variant="outlined"
            onChange={(event) => onChangeInput(event)}
            value={valueInput("descricao")}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <CurrencyInput
            id="precoServicoStart"
            name="precoServicoStart"
            label="Total (R$) De"
            value={valueInput("precoServicoStart")}
            onBlur={(event) => onBlurInput(event)}
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyInput
            id="precoServicoEnd"
            name="precoServicoEnd"
            label="Total (R$) Até"
            value={valueInput("precoServicoEnd")}
            onBlur={(event) => onBlurInput(event)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormFiltroAvancado;
